import { themes } from "../theme/initThemes";
import { Theme } from "@mui/material/styles";
import sleekLayoutSettings, { SleekLayoutSettingsType } from "./sleek-layout/sleekLayoutSettings";

export interface SidebarSettings {
  show: boolean;
  open: boolean;
  theme: string;
}

interface FooterSettings {
  show?: boolean;
  fixed?: boolean;
  theme: string;
  [otherOptions: string]: unknown;
}

export interface LayoutSettings {
  activeLayout: "sleekLayout" | "alternativeLayout";
  activeTheme: string;
  perfectScrollbar: boolean;
  themes: { [key: string]: Theme };
  sleekLayoutSettings: SleekLayoutSettingsType;
  secondarySidebar: SidebarSettings;
  footer: FooterSettings;
}

export const DashboardLayoutSettings: LayoutSettings = {
  activeLayout: "sleekLayout",
  activeTheme: "blue",
  perfectScrollbar: false,
  themes: themes,
  sleekLayoutSettings,
  secondarySidebar: {
    show: true,
    open: false,
    theme: "slateDark1",
  },
  footer: {
    show: true,
    fixed: false,
    theme: "slateDark1",
  },
};